"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.List = void 0;
var _ProductListItem = require("../ProductListItem");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const List = (param)=>{
    let { items } = param;
    if ((items === null || items === void 0 ? void 0 : items.length) == null || items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        children: items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_ProductListItem.ProductListItem, {
                items: item.items,
                name: item.name,
                productListId: item.productListId
            }, item.productListId))
    });
};
exports.List = List;
